import FilterPillController from '../../pos_controllers/products/filter_pill_controller'

export default class extends FilterPillController {
  static targets = [
    'filterTypeSegment',
    'comparatorSegment',
    'valuesSegment',
    'filterTypeDropdown',
    'comparatorDropdown',
    'valuesDropdown',
    'dropdown',
    'dropdownButton'
  ]

  static values = {
    clauseIndex: Number
  }

  toggleFilterTypeDropdown(event) {
    event.preventDefault()
    event.stopPropagation()

    this.closeOtherPillDropdowns()
    this.closeAllSegmentDropdowns()

    const wasHidden = this.filterTypeDropdownTarget.classList.contains('d-none')
    this.filterTypeDropdownTarget.classList.toggle('d-none')

    if (wasHidden && !this.filterTypeDropdownTarget.classList.contains('d-none')) {
      this.positionDropdownBelowSegment(
        this.filterTypeDropdownTarget,
        this.filterTypeSegmentTarget
      )

      this.addScrollListenerForSegment(
        this.filterTypeDropdownTarget,
        this.filterTypeSegmentTarget
      )

      setTimeout(() => {
        const searchableSelect = this.filterTypeDropdownTarget.querySelector('[data-controller*="searchable-select"]')
        if (searchableSelect) {
          const controller = this.application.getControllerForElementAndIdentifier(
            searchableSelect,
            'select--searchable-select'
          )
          if (controller && typeof controller.showDropdown === 'function') {
            controller.showDropdown()
          }
        }
      }, 100)
    }
  }

  toggleComparatorDropdown(event) {
    event.preventDefault()
    event.stopPropagation()

    this.closeOtherPillDropdowns()
    this.closeAllSegmentDropdowns()

    const wasHidden = this.comparatorDropdownTarget.classList.contains('d-none')
    this.comparatorDropdownTarget.classList.toggle('d-none')

    if (wasHidden && !this.comparatorDropdownTarget.classList.contains('d-none')) {
      this.positionDropdownBelowSegment(
        this.comparatorDropdownTarget,
        this.comparatorSegmentTarget
      )

      this.addScrollListenerForSegment(
        this.comparatorDropdownTarget,
        this.comparatorSegmentTarget
      )

      setTimeout(() => {
        const searchableSelect = this.comparatorDropdownTarget.querySelector('[data-controller*="searchable-select"]')
        if (searchableSelect) {
          const controller = this.application.getControllerForElementAndIdentifier(
            searchableSelect,
            'select--searchable-select'
          )
          if (controller && typeof controller.showDropdown === 'function') {
            controller.showDropdown()
          }
        }
      }, 100)
    }
  }

  toggleValuesInput(event) {
    event.preventDefault()
    event.stopPropagation()

    const wrapper = this.element.closest('[data-clause-index]')
    const clauseIndex = wrapper ? parseInt(wrapper.dataset.clauseIndex) : null

    const advancedFilterController = this.getAdvancedFilterController()
    if (!advancedFilterController) return

    const clause = advancedFilterController.searchClauses[clauseIndex]
    if (!clause) return

    const searchOption = advancedFilterController.searchOptions[clause.search_key]
    if (!searchOption) return

    this.closeOtherPillDropdowns()
    this.closeAllSegmentDropdowns()

    if (!this.hasValuesDropdownTarget) return

    this.valuesDropdownTarget.classList.remove('d-none')
    this.positionDropdownBelowSegment(this.valuesDropdownTarget, this.valuesSegmentTarget)

    this.addScrollListenerForSegment(
      this.valuesDropdownTarget,
      this.valuesSegmentTarget
    )

    // Auto-open first searchable select (prioritize single for compatibility Make)
    setTimeout(() => {
      const searchableSelect = this.valuesDropdownTarget.querySelector('[data-controller*="searchable-select"]:not([data-controller*="multi-searchable-select"])')
      if (searchableSelect) {
        const controller = this.application.getControllerForElementAndIdentifier(searchableSelect, 'select--searchable-select')
        if (controller?.showDropdown) controller.showDropdown()
      } else {
        const multiSelect = this.valuesDropdownTarget.querySelector('[data-controller*="multi-searchable-select"]')
        if (multiSelect) {
          const controller = this.application.getControllerForElementAndIdentifier(multiSelect, 'select--multi-searchable-select')
          if (controller?.showDropdown) controller.showDropdown()
        } else {
          const selectElement = this.valuesDropdownTarget.querySelector('select')
          if (selectElement) {
            selectElement.focus()
            // Try to programmatically open the select using showPicker (modern browsers)
            if (typeof selectElement.showPicker === 'function') {
              try {
                selectElement.showPicker()
              } catch (e) {
                // Fallback: simulate click event
                selectElement.dispatchEvent(new MouseEvent('mousedown', { bubbles: true }))
              }
            } else {
              // Fallback for older browsers: simulate click
              selectElement.dispatchEvent(new MouseEvent('mousedown', { bubbles: true }))
            }
          } else {
            // If no select, focus the first input field
            const firstInput = this.valuesDropdownTarget.querySelector('input[type="text"], input[type="number"], input[type="date"]')
            if (firstInput) {
              firstInput.focus()
            }
          }
        }
      }
    }, 150)
  }

  positionDropdownBelowSegment(dropdown, segment) {
    const rect = segment.getBoundingClientRect()
    const viewportWidth = window.innerWidth
    const viewportHeight = window.innerHeight
    const isMobile = viewportWidth <= 768

    void dropdown.offsetHeight

    const dropdownWidth = dropdown.offsetWidth || 450
    const dropdownHeight = dropdown.offsetHeight || 300
    const maxAllowedWidth = viewportWidth - 40

    if (dropdownWidth > maxAllowedWidth) {
      dropdown.style.maxWidth = `${maxAllowedWidth}px`
      void dropdown.offsetHeight
    }

    const actualWidth = Math.min(dropdownWidth, maxAllowedWidth)
    let leftPosition
    let topPosition = rect.bottom + 4

    if (topPosition + dropdownHeight > viewportHeight - 20) {
      topPosition = Math.max(20, viewportHeight - dropdownHeight - 20)
    }

    dropdown.style.top = `${topPosition}px`

    if (isMobile) {
      leftPosition = (viewportWidth - actualWidth) / 2
    } else {
      leftPosition = rect.left

      if (leftPosition + actualWidth > viewportWidth - 20) {
        leftPosition = viewportWidth - actualWidth - 20
      }

      if (leftPosition < 20) {
        leftPosition = 20
      }
    }

    dropdown.style.left = `${leftPosition}px`
  }

  addScrollListenerForSegment(dropdown, segment) {
    // Remove any existing listener first
    this.removeSegmentPositionListeners()

    // Add scroll listener with requestAnimationFrame for smooth repositioning
    this.segmentPositionUpdateHandler = () => {
      if (this.segmentPositionUpdateFrame) {
        cancelAnimationFrame(this.segmentPositionUpdateFrame)
      }
      this.segmentPositionUpdateFrame = requestAnimationFrame(() => {
        this.positionDropdownBelowSegment(dropdown, segment)
      })
    }
    window.addEventListener('scroll', this.segmentPositionUpdateHandler, true)

    // Listen for keyboard close/open to reposition
    if (window.visualViewport) {
      this.segmentKeyboardHandler = () => this.positionDropdownBelowSegment(dropdown, segment)
      window.visualViewport.addEventListener('resize', this.segmentKeyboardHandler)
    }
  }

  removeSegmentPositionListeners() {
    if (this.segmentPositionUpdateHandler) {
      window.removeEventListener('scroll', this.segmentPositionUpdateHandler, true)
      if (this.segmentPositionUpdateFrame) {
        cancelAnimationFrame(this.segmentPositionUpdateFrame)
        this.segmentPositionUpdateFrame = null
      }
      this.segmentPositionUpdateHandler = null
    }

    // Remove keyboard listener
    if (this.segmentKeyboardHandler && window.visualViewport) {
      window.visualViewport.removeEventListener('resize', this.segmentKeyboardHandler)
      this.segmentKeyboardHandler = null
    }
  }

  closeAllSegmentDropdowns() {
    // Remove segment position listeners
    this.removeSegmentPositionListeners()

    if (this.hasFilterTypeDropdownTarget) {
      this.filterTypeDropdownTarget.classList.add('d-none')

      // Also close any searchable select dropdowns inside
      const searchableSelect = this.filterTypeDropdownTarget.querySelector('[data-controller*="searchable-select"]')
      if (searchableSelect) {
        const controller = this.application.getControllerForElementAndIdentifier(
          searchableSelect,
          'select--searchable-select'
        )
        if (controller && typeof controller.hideDropdown === 'function') {
          controller.hideDropdown()
        }
      }
    }
    if (this.hasComparatorDropdownTarget) {
      this.comparatorDropdownTarget.classList.add('d-none')

      const searchableSelect = this.comparatorDropdownTarget.querySelector('[data-controller*="searchable-select"]')
      if (searchableSelect) {
        const controller = this.application.getControllerForElementAndIdentifier(
          searchableSelect,
          'select--searchable-select'
        )
        if (controller && typeof controller.hideDropdown === 'function') {
          controller.hideDropdown()
        }
      }
    }
    if (this.hasValuesDropdownTarget) {
      this.valuesDropdownTarget.classList.add('d-none')

      // Also close any multi-searchable select dropdowns inside
      const multiSelect = this.valuesDropdownTarget.querySelector('[data-controller*="multi-searchable-select"]')
      if (multiSelect) {
        const controller = this.application.getControllerForElementAndIdentifier(
          multiSelect,
          'select--multi-searchable-select'
        )
        if (controller && typeof controller.hideDropdown === 'function') {
          controller.hideDropdown()
        }
      }
    }
  }

  closeOtherPillDropdowns() {
    // Close dropdowns in all other pills
    document.querySelectorAll('[data-controller*="select--filter-pill"]').forEach(element => {
      if (element === this.element) return // Skip this pill

      const controller = this.application.getControllerForElementAndIdentifier(element, 'select--filter-pill')
      if (controller && controller.closeAllSegmentDropdowns) {
        controller.closeAllSegmentDropdowns()
      }
    })
  }

  getAdvancedFilterController() {
    const form = document.querySelector('[data-controller*="select--advanced-filter"]')
    if (form) {
      return this.application.getControllerForElementAndIdentifier(
        form,
        'select--advanced-filter'
      )
    }
    return null
  }

  // Keep legacy toggleDropdown for backward compatibility (deprecated)
  toggleDropdown(event) {
    event.preventDefault()
    event.stopPropagation()

    if (event.target.closest('button[data-action*="removeClause"]')) {
      return
    }

    this.closeAllDropdowns()

    if (this.hasDropdownTarget) {
      const wasHidden = this.dropdownTarget.classList.contains('d-none')
      this.dropdownTarget.classList.toggle('d-none')

      if (wasHidden && !this.dropdownTarget.classList.contains('d-none')) {
        // Opening dropdown
        this.positionDropdown()
        // Add scroll listener with requestAnimationFrame for smooth repositioning
        this.positionUpdateHandler = () => {
          if (this.positionUpdateFrame) {
            cancelAnimationFrame(this.positionUpdateFrame)
          }
          this.positionUpdateFrame = requestAnimationFrame(() => {
            this.positionDropdown()
          })
        }
        window.addEventListener('scroll', this.positionUpdateHandler, true)

        // Listen for keyboard close/open to reposition
        if (window.visualViewport) {
          this.keyboardHandler = () => this.positionDropdown()
          window.visualViewport.addEventListener('resize', this.keyboardHandler)
        }
      } else if (!wasHidden) {
        // Closing dropdown
        this.removePositionListeners()
      }
    }
  }

  closeDropdown() {
    if (this.hasDropdownTarget) {
      this.dropdownTarget.classList.add('d-none')
      this.removePositionListeners()
    }
  }

  removePositionListeners() {
    if (this.positionUpdateHandler) {
      window.removeEventListener('scroll', this.positionUpdateHandler, true)
      if (this.positionUpdateFrame) {
        cancelAnimationFrame(this.positionUpdateFrame)
        this.positionUpdateFrame = null
      }
      this.positionUpdateHandler = null
    }

    // Remove keyboard listener
    if (this.keyboardHandler && window.visualViewport) {
      window.visualViewport.removeEventListener('resize', this.keyboardHandler)
      this.keyboardHandler = null
    }
  }

  disconnect() {
    this.removePositionListeners()
    this.removeSegmentPositionListeners()
    this.closeAllSegmentDropdowns()
    if (super.disconnect) {
      super.disconnect()
    }
  }

  closeAllDropdowns() {
    document.querySelectorAll('[data-controller*="select--filter-pill"]').forEach(element => {
      const controller = this.application.getControllerForElementAndIdentifier(element, 'select--filter-pill')
      if (controller && controller.closeDropdown) {
        controller.closeDropdown()
      }
    })
  }

  removeClause(event) {
    event.preventDefault()
    event.stopPropagation()

    const button = event.target.closest('button[data-clause-index]')
    const clauseIndex = button ? button.dataset.clauseIndex : this.clauseIndexValue

    const advancedFilterController = this.application.getControllerForElementAndIdentifier(
      document.querySelector('[data-controller*="select--advanced-filter"]'),
      'select--advanced-filter'
    )

    if (advancedFilterController) {
      const fakeEvent = {
        target: {
          closest: () => ({
            dataset: {
              clauseIndex: clauseIndex
            }
          })
        }
      }

      advancedFilterController.removeSearchClause(fakeEvent)
    }

    this.closeDropdown()
  }
}

